import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { lazy } from 'react';

import { AppShell } from '@/components/AppShell/AppShell';
import { AuthProvider } from '@/context/AuthContext';
import { ThemeModeProvider } from '@/context/ThemeModeContext';
import { PlaceholderPage } from '@/shared/PlaceholderPage';

const DevToolsPanel = import.meta.env.DEV
  ? lazy(() =>
      import('@/components/DevToolsPanel/DevToolsPanel').then((m) => ({
        default: m.DevToolsPanel,
      })),
    )
  : null;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeModeProvider>
        <AuthProvider>
          <AppShell>
            <Outlet />
          </AppShell>
          {DevToolsPanel && <DevToolsPanel />}
        </AuthProvider>
      </ThemeModeProvider>
    </QueryClientProvider>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: PlaceholderPage,
});
